module.exports = __webpack_public_path__ + "img/icon-dropdown-light.8496b7ca.svg";